/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query SenderIdDirectoryReadQuery($take: PositiveInt!, $skip: Int!) {
    SenderIdDirectoryRead(take: $take, skip: $skip) {
      id,
      displayName,
      message,
      status,
      _totalCount
    }
  }
`
